import { Button } from "../shared/button/button";
import { useNavigate } from "react-router-dom";
import { ContainerLogin } from "./styles";
import {
  LinkStyled,
  NormalText,
  TextFieldStyled,
  TitleStyled,
} from "../shared/styles";
import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { Announcement } from "../shared/announcement/announcement";
import { useSelector } from "react-redux";
import { validateEmail } from "../shared/utils";
// import { useDispatch } from "react-redux";

export const SignUp = () => {
  const [newUser, setNewUser] = useState({
    fullname: "",
    email: "",
    password: "",
    repeatedPassword: "",
    error: "",
    success: false,
  });

  const { data: userData, isLoading: isLoadingUser } = useSelector(
    (state) => state.user
  );

  const navigate = useNavigate();
  // const dispatch = useDispatch();

  function handleChangeUser(e) {
    setNewUser((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
      error: "",
    }));
  }

  function handleCreateUser(e) {
    if (e?.type === "keydown" && e.key !== "Enter") {
      return;
    }

    if (
      !newUser.email ||
      !newUser.fullname ||
      !newUser.password ||
      !newUser.repeatedPassword
    ) {
      setNewUser((prev) => ({
        ...prev,
        error: "You have not entered one or more fields.",
      }));
      return;
    }

    if (!validateEmail(newUser.email)) {
      setNewUser((prev) => ({
        ...prev,
        error: "The email entered does not comply with the required format.",
      }));
      return;
    }

    if (newUser.password !== newUser.repeatedPassword) {
      setNewUser((prev) => ({
        ...prev,
        error: "Passwords must be the same.",
      }));
      return;
    }

    setNewUser({
      fullname: "",
      email: "",
      password: "",
      repeatedPassword: "",
      error: "",
      success: true,
    });

    // dispatch(login(user.username, user.password));
  }

  useEffect(() => {
    if (userData?.success) {
      navigate("/home");
    }
  }, [navigate, userData]);

  return (
    <ContainerLogin>
      <Box margin={"0 auto"}>
        <img src="/logo-tenui.png" alt="Logo Tenui" width={72} />
        {/* <img
          src="/logo-develone-2.png"
          alt="Logo Develone"
          width={72}
        /> */}
      </Box>
      <Box display={"flex"} flexDirection={"column"} gap={"8px"}>
        <TitleStyled>Sign up</TitleStyled>
        <NormalText>Create your account to start transacting!</NormalText>
      </Box>
      <TextFieldStyled
        name={"fullname"}
        placeholder={"Full name"}
        type={"text"}
        variant="standard"
        InputProps={{
          disableUnderline: true,
        }}
        value={newUser.fullname}
        onChange={handleChangeUser}
        onKeyDown={handleCreateUser}
      />
      <TextFieldStyled
        name={"email"}
        placeholder={"Email"}
        type={"text"}
        variant="standard"
        InputProps={{
          disableUnderline: true,
        }}
        value={newUser.email}
        onChange={handleChangeUser}
        onKeyDown={handleCreateUser}
      />
      <TextFieldStyled
        name={"password"}
        placeholder={"Password"}
        type={"password"}
        variant="standard"
        InputProps={{
          disableUnderline: true,
        }}
        value={newUser.password}
        onChange={handleChangeUser}
        onKeyDown={handleCreateUser}
      />
      <TextFieldStyled
        name={"repeatedPassword"}
        placeholder={"Repeat password"}
        type={"password"}
        variant="standard"
        InputProps={{
          disableUnderline: true,
        }}
        value={newUser.repeatedPassword}
        onChange={handleChangeUser}
        onKeyDown={handleCreateUser}
      />
      <Button
        label={"Create user"}
        onClick={handleCreateUser}
        fullWidth
        buttonStyles={{
          padding: "12px",
          minHeight: "47px",
        }}
        isLoading={isLoadingUser}
      />
      <LinkStyled href="/" underline="none">
        Back to login
      </LinkStyled>
      {(newUser?.error || newUser?.success) && (
        <Announcement
          title={newUser?.error ? "Error" : "Sucess"}
          description={newUser?.error || "User created successfully."}
          type={newUser?.error ? "error" : "info"}
        />
      )}
    </ContainerLogin>
  );
};
